import { darken, lighten } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

export const getFormSurfaces = (theme: Theme) => {
  const dark = theme.palette.mode === 'dark';
  const card = dark ? lighten(theme.palette.background.paper, 0.065) : theme.palette.background.paper;
  return { card, editable: darken(card, dark ? 0.2 : 0.025), inactive: dark ? lighten(card, 0.02) : darken(card, 0.008) };
};

export const cardSurfaceStyles = ({ theme }: { theme: Theme }) => ({ backgroundColor: getFormSurfaces(theme).card, backgroundImage: 'none' });
export const outlinedFieldSurfaceStyles = (theme: Theme) => ({ backgroundColor: getFormSurfaces(theme).editable, '&.Mui-disabled, &.Mui-readOnly, &.MuiInputBase-readOnly': { backgroundColor: getFormSurfaces(theme).inactive } });
